module.exports = __webpack_public_path__ + "static/media/sliders-v-square.92f4fb46.svg";